import { render, staticRenderFns } from "./BasicInfoManage.vue?vue&type=template&id=38b2943a&scoped=true"
import script from "./BasicInfoManage.vue?vue&type=script&lang=js"
export * from "./BasicInfoManage.vue?vue&type=script&lang=js"
import style0 from "../../style/large-screen-manage.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./BasicInfoManage.vue?vue&type=style&index=1&id=38b2943a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b2943a",
  null
  
)

export default component.exports